import { render, staticRenderFns } from "./ClaimPayments.vue?vue&type=template&id=698272b6&"
import script from "./ClaimPayments.vue?vue&type=script&lang=js&"
export * from "./ClaimPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports